import React from 'react'
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'

export const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const states = 'AL AK AR AZ CA CO CT DC DE FL GA HI ID IA IL IN KS KY LA MA MD ME MI MO MN MS MT NC ND NE NH NJ NM NY NV OH OK OR PA PR RI SC SD TN TX UT VA VT WA WI WV WY'.split(
  ' '
)

// React nags with a warning when controlled form control has no onChange event handler.
// This stub silences the warning.
// NOTE: only use if a parent catches onChange()
function fake() {}

export function fieldGroup({
  id,
  label,
  help,
  labelCol = 3,
  controlCol = 9,
  ...props
}) {
  let type = props.type || 'text'
  if (!(id in this.type)) {
    this.type[id] = type
    return null
  }

  const validationState = this.state.validationState[id] || null
  let value = this.state.data[id]
  value = typeof value === undefined || value === null ? '' : value

  return (
    <FormGroup controlId={id} {...{ validationState }}>
      <Row>
        <Col xs={labelCol}>
          <ControlLabel>{label}</ControlLabel>
        </Col>
        <Col xs={controlCol}>
          <FormControl
            name={id}
            value={typeof value === undefined || value === null ? '' : value}
            componentClass={type === 'select' ? 'select' : 'input'}
            onChange={this.props.onChange ? this.props.onChange : fake}
            {...props}
            {...(type === 'select' ? {} : { type })}
          />
          <FormControl.Feedback />
        </Col>
        {help && (
          <Col xs={controlCol} xsOffset={12 - controlCol}>
            <HelpBlock>{help}</HelpBlock>
          </Col>
        )}
      </Row>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Forms.js